import type { LogLevel as ConsolaLogLevel, createConsola } from 'consola';
import { LogLevels as ConsolaLogLevels } from 'consola';

import type { Logger, LogLevel } from '~/shared/logger/logger';

const logLevelToConsolaLevel: Readonly<Record<LogLevel, ConsolaLogLevel>> = {
    debug: ConsolaLogLevels.debug,
    error: ConsolaLogLevels.error,
    info: ConsolaLogLevels.info,
    silent: ConsolaLogLevels.silent,
    warn: ConsolaLogLevels.warn,
};

export type ConsoleLoggerDependencies = {
    readonly createConsoleTarget: typeof createConsola;
};

export type ConsoleLoggerOptions = {
    readonly logLevel: LogLevel;
};

export const createConsoleLogger = (dependencies: ConsoleLoggerDependencies, options: ConsoleLoggerOptions): Logger => {
    const consolaLogger = dependencies.createConsoleTarget({
        formatOptions: {
            colors: true,
            compact: true,
            date: true,
        },
        level: logLevelToConsolaLevel[options.logLevel],
    });

    return {
        error(message, ...args) {
            consolaLogger.error(message, ...args);
        },
        info(message, ...args) {
            consolaLogger.info(message, ...args);
        },
        log(message, ...args) {
            consolaLogger.debug(message, ...args);
        },
        warn(message, ...args) {
            consolaLogger.warn(message, ...args);
        },
    };
};
